export default __webpack_public_path__ + "static/media/guide_to_gold.52baba6c.png";